import React from 'react';
import { Spinner } from 'react-bootstrap';
import styles from './loading.module.scss';

const Loading = ({fullscreen=false}) => {
  return (
    <div className={styles[fullscreen?'spinner2':'spinner']}>
      <Spinner size="medium" animation="border" />
    </div>
  )
}

export default Loading;
